export type RowType = {
  name: string
  code: string
  order: number
}

export const ROW_TYPE_ARRIVAL: RowType = {
  name: '入荷',
  code: 'arrival',
  order: 1,
}

export const ROW_TYPE_ARRIVAL_TOTAL: RowType = {
  name: '入荷（ケース）',
  code: 'arrivalCase',
  order: 1,
}

export const ROW_TYPE_ARRIVAL_WEIGHT_TOTAL: RowType = {
  name: '入荷（重量t）',
  code: 'arrivalWeight',
  order: 2,
}

export const ROW_TYPE_SHIP: RowType = {
  name: '出荷',
  code: 'ship',
  order: 3,
}

export const ROW_TYPE_SALES_ORDER: RowType = {
  name: '受注実績',
  code: 'salesOrder',
  order: 4,
}

export const ROW_TYPE_STOCK: RowType = {
  name: '在庫',
  code: 'stock',
  order: 5,
}

export const ROW_TYPE_STOCK_DAYS: RowType = {
  name: '在庫日数',
  code: 'stockDays',
  order: 6,
}

export const ROW_TYPE_REMARKS: RowType = {
  name: '備考',
  code: 'remarks',
  order: 7,
}

export const ROW_TYPE_STOCK_FOLLOW_BY_PRODUCT: RowType = {
  name: '商品別在庫数合計',
  code: 'stockTotal',
  order: 7,
}

export const ROW_TYPE_SHIP_EXCLUSIVE: RowType = {
  name: '出荷止め',
  code: 'olditemShipStopFlg',
  order: 8,
}

export const ROW_TYPE_QUANTITY_STOP_SHIPPING: RowType = {
  name: '出荷止め数量',
  code: 'quantityStopShipping',
  order: 9,
}

export const ROW_TYPE_STOCK_PRODUCT: RowType = {
  name: '商品別在庫日数',
  code: 'stockTotalDays',
  order: 8,
}

export const ROW_TYPE_REMARK: RowType = {
  name: '',
  code: 'remark',
  order: 9,
}



export type StockCell = {
  recDate: Date
  orderDate: Date | null
  value: any | null
  oldValue: number | null
  enableUpdate: boolean
  // 在庫日数計算のため、shipのみ参照する属性
  enableData: boolean
  isUpdate: boolean
  isCurrentUpdate: boolean
  recType: string | null
  fixFlg?: boolean
  isCheckbox?: boolean
  updateDatetime?: Date | null
  stockPlanUpdateDatetime?: Date | null
  isUpdatedArrival?: boolean
  isUpdatedShip?: boolean
  orderQuantityRecommend?: number | null
  orderQuantityRec?: number | null
  shipQuantityScheduled?: number | null
  remarks?: string | null
  olditemShipStopFlg?: boolean
  shipExclusionFlg?: boolean
  resetToRecommend?: boolean
  isOrderConfirmed?: boolean
  isUpdatedArrivalTmp?: boolean
  isOrderDay?: boolean
  isArrivalDay?: boolean
  isTodayOrderDay?: boolean
  stockDaysSetting?: number | null
  minStockQuantity?: number | null
  shipdaysNextArrival?: number | null
  avgShipQuantityStockBase?: number | null
  stockQuantityRec?: number | null
}

export type RenewalSimulatorCell = StockCell &{
  renewalNumberDay: number | null
  colName: string
  colNumber: number
}

export type StockCellWithPk = StockCell & {
  companyId: number
  centerId: number
  itemCode: string
  rowType: RowType
}

export type StockRow = {
  companyId: number
  centerId: number
  centerName?: string | null
  orgSupplierId?: string | null
  supplierName?: string | null
  orgItemCode: string
  itemCode: string | null
  itemName?: string | null
  janCase?: string | null
  expectedRank: number | null
  orderUnitTypeName?: string | null
  caseLot?: number | null
  minOrderQuantity?: number | null
  rowType: RowType | null
  stockDaysSetting: number | null
  safetyStockSetting: number | null
  minStockQuantity: number | null
  startDate: Date | null
  stopShip: boolean | null
  stopArrival: boolean | null
  renewalFlg: boolean | null
  renewalNumber: number | null
  weight?: number | null
  optimizeType: string | null
  isTotal: boolean
  orderQuantityRecommend? : number | null
  shipQuantityScheduled? : number | null
  groupKey?: string
  [key: `col${number}`]: StockCell | null
}
export type RenewalSimulatorRow = StockRow & {
  rowid:string
}

